var _path;
import * as React from "react";
function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 7.556H6.667A2.667 2.667 0 004 10.222v19.556a2.667 2.667 0 002.667 2.666h26.666A2.667 2.667 0 0036 29.778V10.222a2.667 2.667 0 00-2.667-2.666zM12.89 27.778c0 .366-.3.666-.667.666h-4a.669.669 0 01-.666-.666v-2.223c0-.366.3-.666.666-.666h4c.367 0 .667.3.667.666v2.223zm10.667 0c0 .366-.3.666-.667.666h-7.556a.669.669 0 01-.666-.666v-2.223c0-.366.3-.666.666-.666h7.556c.367 0 .667.3.667.666v2.223z"
  })));
}
export default SvgCreditCard;